import { ScentOffIcon } from './ScentOffIcon';

/**
 * author: Michael Irigoyen
 * id 2263B3A2-8BC3-4E1B-B86F-46E9E7CAA92A
 * name scent-off
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/scent-off.svg
 * tags
 */
export const OdorOffIcon = ScentOffIcon;
export default OdorOffIcon